import { render, staticRenderFns } from "./DistancingTypes.vue?vue&type=template&id=7800cf26"
import script from "./DistancingTypes.vue?vue&type=script&lang=js"
export * from "./DistancingTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports